import { render } from "./DetMedSmåt.vue?vue&type=template&id=19670e4a&scoped=true"
import script from "./DetMedSmåt.vue?vue&type=script&lang=js"
export * from "./DetMedSmåt.vue?vue&type=script&lang=js"

import "./DetMedSmåt.vue?vue&type=style&index=0&id=19670e4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19670e4a"]])

export default __exports__